<template>
    <small-dialog
        @ok="create"
        v-model="dialog"
        title="Buat link baru"
        okButton="buat"
        loading="createlink"
    >
        <template #activator="{ on }">
            <div class="text-right">
                <v-btn
                    v-on="on"
                    color="primary"
                    rounded
                >
                    buat baru
                </v-btn>
            </div>
        </template>

        <v-form ref="form">
            <v-text-field
                v-model="form.title"
                label="Nama Link"
                autofocus
            ></v-text-field>

            <v-text-field
                v-model="form.link"
                label="Link"
                :rules="linkRules"
            ></v-text-field>

            <v-text-field
                v-model="form.url"
                label="URL"
            ></v-text-field>
        </v-form>
    </small-dialog>
</template>

<script>
import SmallDialog from '@/components/dialog/SmallDialog'

export default {
    components: {
        SmallDialog,
    },

    data: () => ({
        dialog: false,
        form: {
            title: null,
            link: null,
            url: null,
        },
        linkRules: [
            (v) => (!!v && /^\S+$/.test(v)) || 'Link tidak boleh ada spasi',
        ],
    }),

    methods: {
        async create() {
            await this.$apiv2.post('link', this.form, { loader: 'createlink' })

            this.$refs.form.reset()
            this.dialog = false
            this.$emit('create')
        },
    },
}
</script>
